import { useEffect, useMemo } from 'react';
import useAd from 'lib/hooks/useAd';
import { useDispatch } from 'react-redux';
import { adComponentReadyToReload, adComponentTearingdown } from 'redux-implementations/googleAds';
import { AdConfigBeforeInitialization } from 'types/AdConfig';

export default function useRefreshingAd(
  adConfig: AdConfigBeforeInitialization,
  load = true,
  refreshTime: number,
  refreshLimit: number
): { elementId?: string; isShown: boolean } {
  const dispatch = useDispatch();
  const { elementId, isShown } = useAd(adConfig, load);

  const fullAdConfig = useMemo(() => {
    return { elementId, ...adConfig };
  }, [elementId, adConfig]);

  useEffect(() => {
    if (isShown) {
      let refreshCount = 0;
      const refreshIntervalHandler = setInterval(() => {
        dispatch(adComponentReadyToReload(fullAdConfig));
        refreshCount += 1;
        if (refreshCount >= refreshLimit) {
          clearInterval(refreshIntervalHandler);
        }
      }, refreshTime);

      return (): void => {
        clearInterval(refreshIntervalHandler);
        dispatch(adComponentTearingdown(fullAdConfig));
      };
    }

    return undefined;
  }, [adConfig, dispatch, elementId, fullAdConfig, isShown, refreshLimit, refreshTime]);

  return { elementId, isShown };
}
